import { AuditHistoryDialog } from '../../audit/scripts/audit-history.dialog';

export class StudyStatusDialog {

    statusList: {Id: number, Name: string}[];
    siteStudyId: number;
    auditHistoryDialog: AuditHistoryDialog | null = null;

    successCallback: (response) => void;

    constructor(statusList, auditHistoryDialog?: AuditHistoryDialog) {
        this.statusList = statusList;
        if (auditHistoryDialog) this.auditHistoryDialog = auditHistoryDialog;

        this.initialize();
    }

    initialize() {
        const options = this.statusList.map((s) => new Option(s.Name, s.Id.toString()));

        $('#StatusNewStatus').append(options);

        $('#editStatusDialog .ctms-button-save').on('click', this.saveDialog.bind(this));

        if (this.auditHistoryDialog) {
            $('#editStatusDialog').on('click', '.ctms-icon-history[data-audit-field]', (evt) => {
                const icon = $(evt.currentTarget);
                const entityType = (icon.data('entity-type') as string) || 'SiteStudy';
                const fieldName = icon.data('audit-field') as string;
                const fieldLabel = icon.data('audit-label') as string;
                const entityId = Number($('#SiteStudyId').val());
                this.auditHistoryDialog.show(entityType, entityId, fieldName, fieldLabel);
            });
        }
    }

    resetDialog(siteStudyId, statusId, studyName) {
        this.siteStudyId = siteStudyId;
        $('#StatusNewStatus').val(statusId);
        $('#StatusStudy').text(studyName);
        $('#SiteStudyId').val(siteStudyId);
        $('#StatusComment').val("");

        $('#StatusChangeDate').val(new Date().toISOString().split('T')[0]);
    }

    saveDialog(evt: JQuery.ClickEvent) {
        const token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');

        $('#editStatusDialog .ctms-button-save').prop('disabled', true);
        $('#editStatusSaveSpinner').show();
        $.ajax({
            url: `/secure/ctms/sites/site-details?handler=UpdateStudyStatus`,
            headers: { "RequestVerificationToken": token },
            type: 'POST',
            data: $('#studyStatusForm .ctms-field-submit').serialize(),
            success: (resp) => {
                if (this.successCallback) this.successCallback(resp);
                $('#editStatusDialog').modal('hide');
            },
            complete: () => {
                $('#editStatusDialog .ctms-button-save').prop('disabled', false);
                $('#editStatusSaveSpinner').hide();
            }
        });

        evt.preventDefault();
        evt.stopPropagation();
    }


}